import { useMutation } from "react-query";
import { postItem } from "../../../../../queries/queries-helper.ts";
import { GEOMETRIES_ENDPOINTS } from "../../../../../services/endpoints.ts";

const useProjectMeasureSync = () => {
    const updateProjectSpaces = useMutation({
        mutationFn: (projectId: string) => postItem<string[]>(GEOMETRIES_ENDPOINTS.UPDATE_PROJECT_SPACES(projectId))
    });

    const updateProjectOpenings = useMutation({
        mutationFn: (projectId: string) => postItem<string[]>(GEOMETRIES_ENDPOINTS.UPDATE_PROJECT_OPENINGS(projectId))
    });

    const updateProjectWalls = useMutation({
        mutationFn: (projectId: string) => postItem<string[]>(GEOMETRIES_ENDPOINTS.UPDATE_PROJECT_WALLS(projectId))
    });

    const updateProjectSlabs = useMutation({
        mutationFn: (projectId: string) => postItem<string[]>(GEOMETRIES_ENDPOINTS.UPDATE_PROJECT_SLABS(projectId))
    });

    return {
        updateProjectSpaces,
        updateProjectOpenings,
        updateProjectWalls,
        updateProjectSlabs
    };
}

export default useProjectMeasureSync;